<template>
    <Fragment>

        <catalog-items-list v-if="view == 'list'" :items="items"></catalog-items-list>
        <catalog-items-grid v-else :items="items"></catalog-items-grid>

        <div v-if="nextUrl" class="d-grid mt_md">
            <button
                class="btn btn_lg btn_common w-100"
                type="button"
                @click.prevent="getItems"
            >
                Ещё товары
            </button>
        </div>

    </Fragment>

</template>

<script>
import { Fragment } from "vue-fragment";

export default {

    components: { Fragment },

    props: ["id", "url", "view"],

    data: function () {
        return {
            items: [],
            nextUrl: this.url,
        };
    },
    methods: {
        getItems() {
            axios.get(this.nextUrl).then(({data}) => {
                this.items =[
                    ...this.items,
                    ...data.paginator.data
                ];

                this.nextUrl = data.url;

                this.$store.dispatch('catalog/setCurrentPage', data.paginator.current_page);
            }).catch((err) => {
                console.error(err);
            });
        },
    },
    computed: {
        isAuth() {
            return this.$store.state.isAuth;
        },

        email() {
            return this.$store.state.email;
        },
    },
};
</script>
